import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getViewType } from "ducks/catalog/selectors";
import { setViewType } from "ducks/catalog/catalog";
import { ResourceViewType } from "../components/ViewType/types";

export const useViewType = (): [ResourceViewType, (newViewType: ResourceViewType) => void] => {
  const viewType = useSelector(getViewType);
  const dispatch = useDispatch();

  const updateViewType = useCallback(
    newViewType => {
      dispatch(setViewType(newViewType));
    },
    [dispatch],
  );

  return [viewType, updateViewType];
};
